import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "excerpt" }
const _hoisted_4 = { class: "meta" }
const _hoisted_5 = { class: "dates" }
const _hoisted_6 = {
  key: 0,
  class: "date"
}
const _hoisted_7 = { class: "date-label" }
const _hoisted_8 = {
  key: 1,
  class: "date updated"
}
const _hoisted_9 = { class: "date-label" }
const _hoisted_10 = { class: "read-more" }

import { useI18n } from 'vue-i18n';
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import type { ArticleMeta } from '@/types/articles'


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleCard',
  props: {
    article: {}
  },
  setup(__props: any) {

const props = __props
const { t, locale } = useI18n();
const router = useRouter()

const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}-${month}-${year} ${hours}:${minutes}`
}

const formattedDate = computed(() => formatDate(props.article.date))

const formattedUpdatedAt = computed(() => {
  if (props.article.updatedAt && props.article.updatedAt !== props.article.date) {
    return formatDate(props.article.updatedAt)
  }
  return null
})

const navigateToArticle = () => {
    router.push({ name: 'Article', params: { id: props.article.slug } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: "article-card",
    onClick: navigateToArticle
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.article.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.article.excerpt), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.article.date)
            ? (_openBlock(), _createElementBlock("time", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("articles.published")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(formattedDate.value), 1)
              ]))
            : _createCommentVNode("", true),
          (formattedUpdatedAt.value)
            ? (_openBlock(), _createElementBlock("time", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("articles.updated")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(formattedUpdatedAt.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)("articles.readMore")), 1)
      ])
    ])
  ]))
}
}

})